import React from 'react';

// Mawbot — o mascote/assistente do MAW. 🤖
// Cara de telinha (combina com app/IA), antena com "moeda" dourada e um escudo
// com $ no peito (o "guarda-costas" das finanças). Usa as cores do tema via
// currentColor quando possível, mas o corpo é roxo fixo pra manter a identidade
// nos dois temas. `mood`: 'normal' | 'alert' (alerta pro guarda-costas).
// `size` em px (quadrado).
export default function Mawbot({ size = 96, mood = 'normal', style, className }) {
  const alert = mood === 'alert';
  return (
    <svg
      width={size} height={size} viewBox="0 0 120 120"
      className={className} style={style}
      role="img" aria-label="Mawbot, assistente do MAW"
    >
      {/* antena */}
      <line x1="60" y1="16" x2="60" y2="28" stroke="#9b8cff" strokeWidth="3" />
      <circle cx="60" cy="13" r="5.5" fill={alert ? '#ff5a5f' : '#c9a227'} />

      {/* cabeça */}
      <rect x="24" y="28" width="72" height="56" rx="20" fill="#6d5efc" />
      <rect x="33" y="40" width="54" height="32" rx="13" fill="#17122e" />

      {/* rosto */}
      {alert ? (
        <>
          <path d="M43 52 l6 5 -6 5" stroke="#ffb020" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M77 52 l-6 5 6 5" stroke="#ffb020" strokeWidth="3.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="60" cy="64" r="3" fill="#ffb020" />
        </>
      ) : (
        <>
          <circle cx="49" cy="55" r="6.5" fill="#4fe0c0" />
          <circle cx="71" cy="55" r="6.5" fill="#4fe0c0" />
          <path d="M51 64 Q60 70 69 64" stroke="#4fe0c0" strokeWidth="3" fill="none" strokeLinecap="round" />
        </>
      )}

      {/* corpo + escudo com $ */}
      <rect x="37" y="88" width="46" height="26" rx="11" fill="#8f82f7" />
      <path d="M60 94 l10 5 -10 6 -10-6 Z" fill="#fff" />
      <text x="60" y="104" fontSize="9" fontWeight="900" fill="#6d5efc" textAnchor="middle">$</text>
    </svg>
  );
}
